import React from 'react';
import { Globe, Code } from 'lucide-react';

function Footer({ onAdminClick, isAdmin, onOpenStory }) {
    const handleStoryClick = (e) => {
        e.preventDefault();
        onOpenStory?.();
    };

    return (
        <footer className="bg-slate-50 border-t border-slate-200 pt-12 md:pt-16 pb-8">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 mb-12">
                    <div className="col-span-1 sm:col-span-2">
                        <div className="flex items-center gap-2 mb-4">
                            <div className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center text-white font-bold">E</div>
                            <span className="font-bold text-slate-900 text-lg">EZEMS Tech</span>
                        </div>
                        <p className="text-slate-500 text-sm max-w-xs">Building the digital infrastructure of tomorrow, today. Proudly Kenyan.</p>
                    </div>

                    <div>
                        <h4 className="font-bold text-slate-900 mb-4">Services</h4>
                        <ul className="space-y-2 text-sm text-slate-500">
                            <li>Web Development</li>
                            <li>Mobile Apps</li>
                            <li>Cloud Hosting</li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-bold text-slate-900 mb-4">Company</h4>
                        <ul className="space-y-2 text-sm text-slate-500">
                            <li>About Us</li>
                            <li>Portfolio</li>
                            <li>Contact</li>
                            <li>
                                <a
                                    href="#our-story"
                                    onClick={handleStoryClick}
                                    className="hover:text-blue-600 transition-colors cursor-pointer"
                                >
                                    Our Story
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 border-t border-slate-200 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-400 text-center md:text-left">
                    <p>
                        <button
                            onClick={onAdminClick}
                            className={`transition-colors font-bold ${isAdmin ? 'text-blue-600' : 'hover:text-slate-900'}`}
                        >
                            &copy;
                        </button> {new Date().getFullYear()} EZEMS Tech Developers.
                    </p>
                    <div className="flex gap-4 items-center">
                        <Globe size={16} />
                        <Code size={16} />
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;